<div class="row">
  <div class="col">
    <h3>{{ 'i18n.domain.vehicles.title' | translate }}</h3>
    <p class="text-muted">{{ 'i18n.domain.vehicles.subtitle' | translate }}</p>
  </div>
</div>
<div class="row align-items-center">
  <div class="col-12">
    <div class="d-flex align-items-center mb-2">
      <app-search-field (searchTextChanged)="onSearchTextChanged($event)"></app-search-field>
    </div>
  </div>
</div>
<div class="control-section">
  <ejs-grid #grid
    class="grid-with-toolbar"
    width='100%'
    rowHeight='38'
    [dataSource]='data'
    [allowSorting]='true'
    [filterSettings]='filterSettings'
    [allowFiltering]='true'
    [allowPaging]='true'
    [pageSettings]='pageSettings'
    [editSettings]='editSettings'
    [searchSettings]="searchOptions"
    (actionBegin)="actionBegin($event)"
    (actionComplete)="actionComplete($event)"
    (commandClick)="commandClick($event)">
    <e-columns>
      @for (column of gridColumns; track column.field) {
        <e-column
          [headerText]='column.headerKey | translate'
          [field]='column.field'
          [type]='column.type ?? "string"'
          [visible]='isColumnVisible(column.field, column.visible)'
          [width]='column.width'
          [clipMode]='column.clipMode'
          [isPrimaryKey]='isPrimaryKeyColumn(column.field)'
          [allowFiltering]='isFilteringAllowed(column.allowFiltering)'
          [filter]='getColumnFilter(column.field, column.allowFiltering)'>
        </e-column>
      }
      <e-column headerText="" [commands]='gridCommands'></e-column>
    </e-columns>
  </ejs-grid>
</div>

<app-assign-profile-dialog
  [vehicle]="selectedVehicle"
  [(visible)]="showAssignDialog"
  (assigned)="onAssigned()">
</app-assign-profile-dialog>
